const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '招标采购计划信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '项目计划附件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '批复文件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '计划创建人信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '计划审核流程',
    },
  },
  {
    component: 'ZlmTabDetail',
    options: {
      title: '流程',
      data: [], // 7
    },
  },
]

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
      details: {},
      leibeiArr: [],
      needOpinion: true,
    }
  },
  methods: {
    getData() {
      this.getBaseInfo()
    },
    getBaseInfo() {
      const guid = this.$route.query.id
      this.$request
        .post(
          `/transformToAfter/app/bid/pro/plan/getJiHuaDetail`,
          {
            guid: guid,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.details = res.data
          this.config[3].options.groupId = res.data.jiHuaFuJian
          this.config[5].options.groupId = res.data.pifuWenjian
          this.config[1].options.data = {
            项目计划名称: res.data.projectName,
            项目计划编号: res.data.projectNo,
            计划招标时间: this.$util.timeFormatter(
              res.data.planProcurementTime,
            ),
            计划开工时间: this.$util.timeFormatter(
              res.data.startOrDeliveryTime,
            ),
            '项目估算（万元）': res.data.estimatedAmount,
            '工期/服务期（月）': res.data.gongQi,
            采购类型: this.getCaiGouType(res.data.zbCaigouLiexingChoose),
            项目性质: res.data.xiangmuXingzhi === 1 ? '预算投资采购' : '承接项目分包采购',
            询比方式: res.data.xunbiFangshi === 1 ? '公开询比' : '邀请询比',
            行业: this.getHangYe(res.data.hangYe),
            项目计划级别: res.data.jiHuaJiBie === 1 ? '一般项目' : '重大项目',
            计划类型: res.data.ifJicaijihua === 0 ? '单项计划（单个项目独立采购）' : '预集采计划（片区化或集中采购）',
            采购计划批复状态: res.data.isApproval ? '已批复' : '未批复',
            批复单位: res.data.pifuDanwei,
            // 批文编号: res.data.piwenBianhao,
            类别: this.getLeiBie(res.data.yiJiFenLei, res.data.erJiFenLei, res.data.sanJiFenLei),
            项目概况: res.data.remark,
            变更说明: res.data.chongxinTiJiaoExplain,
          }
          if (res.data.zbCaigouLiexingChoose === '5') {
            this.config[1].options.data = {
              ...this.config[1].options.data,
              商城采集: res.data.isShop === 1 ? '是' : '否',
              邀请单位: res.data.yaoqingDanwei,
            }
          }

          if (!res.data.xunbiFangshi) {
            delete this.config[1].options.data.询比方式
          }
          if (!res.data.chongxinTiJiaoExplain) {
            delete this.config[1].options.data.变更说明
          }
          if (!res.data.isApproval) {
            delete this.config[1].options.data.批复单位
            delete this.config[1].options.data.批复编号
          }
          this.config[7].options.data = {
            计划创建单位: res.data.tibaoDepartment,
            联系人: res.data.submitUser,
            联系电话: res.data.phoneNum,
            填报日期: this.$util.timeFormatter(res.data.submitTime),
          }
          this.config[9].options.data = res.data.shenherenList.map((t) => ({
            审核级别: t.level,
            审核人员: t.userName,
            职务: t.job,
            单位部门: t.qiyeName + '--' + t.deptName,
          }))
          console.log(this.config[1].options.data)
        })
    },
    getAuditList() {
      this.$request
        .post(`/transformToAfter/app/project/sign/getRecord`, {
          guid: this.$route.query.id,
          businessType: 4,
        })
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.config[11].options.data = res.data.map(
              (t) => ({
                提交人: t.submitter,
                提交时间: this.$util.timeFormatter(t.submitTime),
                审批人: t.auditName,
                职务: t.job,
                审批结果: this.getShenHeJieGuo(t.statusMsg),
                审核时间: this.$util.timeFormatter(t.auditTime),
                审批意见: t.auditOpinion,
              }),
            )
          }
        })
    },
    pass(opinion) {
      this.planReportApprove({
        planId: this.$route.query.id,
        remark: opinion,
        status: 1,
        zbCaigouLiexing: this.details.zbCaigouLiexing,
        zbCaigouLiexingChoose: null,
      })
      // this.commit()
    },
    fail(opinion) {
      this.planReportApprove({
        planId: this.$route.query.id,
        remark: opinion,
        status: 2,
        zbCaigouLiexing: this.details.zbCaigouLiexing,
        zbCaigouLiexingChoose: null,
      })
      // this.commit({
      //     opValue: '2', // 不通过
      //     opinion: opinion,
      // })
    },
    // 审核结果
    getShenHeJieGuo(type) {
      let result = ''
      switch (type) {
        case 0:
          result = '未审批'
          break
        case 1:
          result = '审批通过'
          break
        case 2:
          result = '审批驳回'
          break
        case 3:
          result = '流程撤回'
          break
        default:
          break
      }
      return result
    },
    // 采购方式    公开招标 1 邀请招标 2 询比采购 3 谈判采购 4 直接采购5 竞价6
    getCaiGouType(type) {
      let result = '公开招标'
      switch (type) {
        case '1':
          result = '公开招标'
          break
        case '2':
          result = '邀请招标'
          break
        case '3':
          result = '询比采购'
          break
        case '4':
          result = '谈判采购'
          break
        case '5':
          result = '直接采购'
          break
        case '6':
          result = '竞价'
          break
        default:
          break
      }
      return result
    },
    // 行业 1、交通运输 2、房地产 3、金融
    getHangYe(type) {
      let result = '交通运输'
      switch (type) {
        case 1:
          result = '交通运输'
          break
        case 2:
          result = '房地产'
          break
        case 3:
          result = '金融'
          break
        default:
          break
      }
      return result
    },
    getLeiBie(yiji, erji, sanji) {
      const projectType = [
        {
            code: 0,
            name: '工程',
            children: [
                { code: 11, name: '主线土建工程', children: [{ code: 99, name: '其他' }] },
                { code: 12, name: '机电工程', children: [{ code: 99, name: '其他' }] },
                { code: 13, name: '小区房建工程', children: [{ code: 99, name: '其他' }] },
                { code: 14, name: '养护工程', children: [{ code: 99, name: '其他' }] },
                { code: 15, name: '机电养护维护工程', children: [{ code: 99, name: '其他' }] },
                { code: 16, name: '施工', children: [{ code: 99, name: '其他' }] },
                { code: 17, name: '高速公路项目新建、改扩建工程', children: [
                    { code: 171, name: '路基、桥梁、隧道工程' },
                    { code: 172, name: '路面工程' },
                    { code: 173, name: '交安设施及预埋管线工程' },
                    { code: 174, name: '绿化及环境保护设施' },
                    { code: 175, name: '机电工程' },
                    { code: 176, name: '附属小区房建工程' },
                ] },
                { code: 18, name: '高速公路项目养护工程', children: [
                    { code: 181, name: '日常养护' },
                    { code: 182, name: '预防养护' },
                    { code: 183, name: '修复养护' },
                    { code: 184, name: '专项养护' },
                    { code: 185, name: '综合养护' },
                ] },
                { code: 19, name: '房地产开发、客运物流站场建设、服务区增建改造、 基地建设等项目', children: [
                    { code: 191, name: '房屋建筑工程' },
                    { code: 192, name: '装饰工程' },
                    { code: 193, name: '园林绿化和景观工程' },
                    { code: 194, name: '信息化工程、其他工程项目' },
                ] },
                { code: 99, name: '其他', children: [{ code: 99, name: '其他' }] },
            ],
        },
        {
            code: 1,
            name: '货物',
            children: [
                { code: 21, name: '标准材料采购', children: [{ code: 99, name: '其他' }] },
                { code: 22, name: '设备采购安装', children: [{ code: 99, name: '其他' }] },
                { code: 23, name: '车辆（设备）采购', children: [{ code: 99, name: '其他' }] },
                { code: 24, name: '高速公路建设物资', children: [
                    { code: 241, name: '钢筋、水泥、沥青' },
                    { code: 242, name: '桥梁伸缩装置、支座、缆索、锚具等' },
                ] },
                { code: 25, name: '房屋建筑装饰材料', children: [
                    { code: 251, name: '门、窗、幕墙' },
                    { code: 252, name: '墙地砖、石材' },
                    { code: 253, name: '洁具、灯具' },
                    { code: 254, name: '其他装饰材料' },
                ] },
                { code: 26, name: '其他货物', children: [
                    { code: 261, name: '电梯、空调系统' },
                    { code: 262, name: '消防设备' },
                    { code: 263, name: '车辆、养护、救援设备' },
                    { code: 264, name: '办公、生活用品，服装' },
                    { code: 265, name: '软件等信息化产品' },
                    { code: 266, name: '其他设备、材料' },
                ] },
                { code: 99, name: '其他', children: [{ code: 99, name: '其他' }] },
            ],
        },
        {
            code: 2,
            name: '服务',
            children: [
                { code: 37, name: '工可、勘察、设计（包括前期专题研究）', children: [{ code: 99, name: '其他' }] },
                { code: 38, name: '监理服务', children: [{ code: 99, name: '其他' }] },
                { code: 39, name: '试验检测', children: [{ code: 99, name: '其他' }] },
                { code: 40, name: '科研开发', children: [{ code: 99, name: '其他' }] },
                { code: 41, name: '信息化开发、服务类', children: [{ code: 99, name: '其他' }] },
                { code: 42, name: '咨询服务', children: [{ code: 99, name: '其他' }] },
                { code: 43, name: '保险服务', children: [{ code: 99, name: '其他' }] },
                { code: 44, name: '融资服务', children: [{ code: 99, name: '其他' }] },
                { code: 45, name: '文化宣传服务', children: [{ code: 99, name: '其他' }] },
                { code: 99, name: '其他服务项目', children: [{ code: 99, name: '其他' }] },
            ],
        },
        {
            code: 3,
            name: '其他',
            children: [
                { code: 37, name: '其他', children: [{ code: 99, name: '其他' }] },
            ],
        },
    ]
    projectType.forEach((item) => {
      if (item.code === yiji) {
        this.leibeiArr.push(item.name)
        this.recursion(item.children, erji, sanji)
      }
    })
    return this.leibeiArr.join()
    },
    recursion(val, code, sanji) {
        val.forEach((item) => {
          if (item.code === code) {
            this.leibeiArr.push(item.name)
            console.log(this.leibeiArr)
            if (item.children) {
              this.recursion(item.children, sanji)
            }
          }
        })
    },
  },
}

module.exports = {
  config,
  mixin,
}
